var oldScrollY = window.scrollY;
function scrollingClass(event) {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if(y === 0) {
        document.body.classList.remove('scrolling');
        document.body.classList.remove('scrolling-up');
        document.body.classList.remove('scrolling-down');
    } else {
        document.body.classList.add('scrolling');
    }
    if(oldScrollY < y){
        document.body.classList.add('scrolling-down');
        document.body.classList.remove('scrolling-up');
    } else {
        document.body.classList.add('scrolling-up');
        document.body.classList.remove('scrolling-down');
    }
    oldScrollY = y;
}

window.addEventListener('scroll', scrollingClass);
scrollingClass();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) {
        return;
    }
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  if(!container) {
      return
  }
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function wrapIframe(options) {
    options.iframes.forEach(function(iframe) {
        var wrapper = document.createElement('div');
        wrapper.classList.add(options.iframeWrapperClass);

        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);

        iframe.src = iframe.src;
    });
}

document.addEventListener("swiper-loaded", function(event) {
    renderSwatches()
})

document.addEventListener("recommendations-loaded", function(event) {
    renderSwatches()
})

function renderSwatches() {
    let swatches = document.querySelectorAll('.swatches > .swiper')
    if(swatches.length > 0) {
        swatches.forEach((swatch) => {
            const swiper = new Swiper(swatch, {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                nested: true,
//                 enabled: false,
//                 noSwiping: true,
//                 loopAdditionalSlides:0,
                rewind: true,
                slidesPerView: 4,
                spaceBetween : 7,
                initialSlide: 0,
                navigation: {
                    nextEl: swatch.parentElement.querySelector('.button-next'),
                }
            });
            const nextButton = swatch.parentElement.querySelector('.button-next');
            if (nextButton) {
                nextButton.addEventListener('keydown', function(event) {
                    if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
                        event.preventDefault();
                        nextButton.click();
                    }
                });
            }
        })
    }
    let allSwatches = document.querySelectorAll('.swatches')
    if(allSwatches.length > 0) {
        allSwatches.forEach((swatch) => {
            let swatchItems = swatch.querySelectorAll('.swatch')
            if(swatchItems.length > 0) {
                swatchItems.forEach((swatchItem) => {
                    swatchItem.addEventListener('keydown', function(event){
                        if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
                            event.preventDefault();
                            swatchItem.click();
                        }
                    });
                    swatchItem.addEventListener('click', function(){
                        let variantId = swatchItem.dataset.variantId;
                        var cardProduct = swatchItem.closest('.card.product')
                        let image = this.dataset.image;
                        let alternateImage = this.dataset.imageAlternate;
                        let url = this.dataset.url;
                        let limited = this.dataset.limited;
                        if(limited) {
                            cardProduct.classList.add('limited')
                        } else {
                            cardProduct.classList.remove('limited')
                        }
                        let label = this.dataset.label;
                        let labelProduct = cardProduct.dataset.label;
                        let labelEl = cardProduct.querySelector('.product-label')
                        if(label) {
                            labelEl.innerHTML = label;
                            labelEl.classList.remove('hidden');
                        } else if(labelProduct) {
                            labelEl.innerHTML = labelProduct;
                            labelEl.classList.remove('hidden');
                        } else {
                            labelEl.innerHTML = '';
                            labelEl.classList.add('hidden');
                        }
                        let offerBadgeEl = cardProduct.querySelector('.offer-badge');
                        if (offerBadgeEl) {
                            let offerBadgeData = null;
                            try {
                                offerBadgeData = this.dataset.offerBadge ? JSON.parse(this.dataset.offerBadge) : null;
                            } catch (e) {
                                offerBadgeData = null;
                            }
                            if (offerBadgeData && offerBadgeData.name) {
                                offerBadgeEl.innerHTML = offerBadgeData.name;
                                offerBadgeEl.style.backgroundColor = offerBadgeData.background_color || '';
                                offerBadgeEl.style.color = offerBadgeData.color || '';
                                offerBadgeEl.classList.remove('hidden');
                            } else {
                                offerBadgeEl.innerHTML = '';
                                offerBadgeEl.removeAttribute('style');
                                offerBadgeEl.classList.add('hidden');
                            }
                        }
                        var img = cardProduct.querySelector('.image .primary');
                        var imgAlt = cardProduct.querySelector('.image .alternate');
                        var links = cardProduct.querySelectorAll('a');
                        img.setAttribute('src', image)
                        imgAlt.setAttribute('src', alternateImage)
                        img.removeAttribute('srcset');
                        imgAlt.removeAttribute('srcset');
                        swatchItem.parentElement.querySelectorAll('.swatch').forEach((sibling) => {
                            sibling.classList.remove('active');
                        })
                        swatchItem.classList.add('active');
                        links.forEach((link) => {
                            link.setAttribute('href', url);
                        })
                        const priceContainer = cardProduct.querySelector('.actions .price');
                        if (priceContainer) {
                            const swatchPrice = Number(this.dataset.price || 0);
                            const swatchCompareAtPrice = Number(this.dataset.compareAtPrice || 0);
                            const swatchDiscountPercent = Number(this.dataset.discountPercent || 0);
                            const swatchDiscountLabel = this.dataset.discountLabel || (swatchDiscountPercent > 0 ? `${swatchDiscountPercent}% OFF` : '');
                            const hasDiscount = swatchCompareAtPrice > swatchPrice || swatchDiscountLabel.length > 0;
                            const saleRegularPrice = priceContainer.querySelector('.price__sale .price-item--regular');
                            const salePrice = priceContainer.querySelector('.price__sale .price-item--sale');
                            const regularPrice = priceContainer.querySelector('.price__regular .price-item--regular');
                            const discountPercent = priceContainer.querySelector('.discount-percent');

                            if (hasDiscount) {
                                priceContainer.classList.add('price--on-sale');
                                if (saleRegularPrice) saleRegularPrice.innerHTML = swatchCompareAtPrice > swatchPrice ? formatMoney(swatchCompareAtPrice) : '';
                                if (salePrice) salePrice.innerHTML = formatMoney(swatchPrice);
                                if (regularPrice) regularPrice.innerHTML = formatMoney(swatchPrice);
                                if (discountPercent) discountPercent.innerHTML = swatchDiscountLabel;
                            } else {
                                priceContainer.classList.remove('price--on-sale');
                                if (saleRegularPrice) saleRegularPrice.innerHTML = formatMoney(swatchPrice);
                                if (salePrice) salePrice.innerHTML = '';
                                if (regularPrice) regularPrice.innerHTML = formatMoney(swatchPrice);
                                if (discountPercent) discountPercent.innerHTML = '';
                            }
                        }
//                         cardProduct.querySelectorAll('.actions > .price').forEach((price) => {
//                             if(price.dataset.variantId == variantId) {
//                                 price.classList.remove('hidden');
//                             } else {
//                                 price.classList.add('hidden');
//                             }
//                         })
                    });
                })
                const activeSwatch = swatch.querySelector('.swatch.active') || swatchItems[0];
                if (activeSwatch) {
                    activeSwatch.click();
                }
            }
        })
    }
}

class MegaMenu extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.items = this.querySelectorAll('.header-menu.mega');
        this.menus = this.querySelectorAll('.header-menu-content > .wrapper');
        this.links = this.querySelectorAll('.header-menu-content .menu-links a');

        // Pair each trigger with its submenu content (they are rendered as
        // adjacent siblings: <a class="header-menu mega"> + <nav class="header-menu-content">).
        this.pairs = Array.from(this.items).map((item) => ({
            item: item,
            content: item.nextElementSibling,
        }));

        this.suppressFocusOpen = false;

        this.items.forEach((item) => {
            item.addEventListener('mouseenter', this.menuOpen.bind(this));
            item.addEventListener('mouseleave', this.menuClose.bind(this));
            // Opening on focus lets keyboard users see and reach the submenu
            // the same way mouse users do on hover. When Escape programmatically
            // returns focus to the trigger, skip the very next focus-open so the
            // submenu actually stays closed instead of reopening itself.
            item.addEventListener('focus', (event) => {
                if (this.suppressFocusOpen) {
                    this.suppressFocusOpen = false;
                    return;
                }
                this.menuOpen(event);
            });
            item.addEventListener('keydown', this.onTriggerKeydown.bind(this));
        });
        this.menus.forEach((menu) => {
            menu.addEventListener('mouseenter', this.menuEnter.bind(this));
            menu.addEventListener('mouseleave', this.menuClose.bind(this));
        });
        this.pairs.forEach(({ item, content }) => {
            if (!content) return;
            content.addEventListener('keydown', (event) => this.onContentKeydown(event, item, content));
            // If focus leaves both the trigger and its submenu, close it right away.
            item.addEventListener('focusout', (event) => this.onFocusOut(event, item, content));
            content.addEventListener('focusout', (event) => this.onFocusOut(event, item, content));
        });
        if(this.links.length > 0) {
            let self = this
            this.links.forEach((link)=>{
                link.addEventListener('click',()=>{
                    self.menuClose()
                })
            })
        }
    }

    getContentFor(item) {
        const pair = this.pairs.find((pair) => pair.item === item);
        return pair ? pair.content : null;
    }

    setExpanded(item, expanded) {
        item.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    menuClose(event) {
        let $self = this;
        this.timer = setTimeout(function(){
            document.querySelector('body').classList.remove('desktop-menu-open');
            $self.items.forEach((item) => {
                item.classList.remove('active');
                $self.setExpanded(item, false);
            })
        }, 400);
    }

    menuEnter(event) {
        clearTimeout(this.timer);
    }

    menuOpen(event) {
        var clickedItem = event.target;
        clearTimeout(this.timer);
        clickedItem.classList.add('active');
        this.setExpanded(clickedItem, true);
        document.querySelector('body').classList.add('desktop-menu-open');
        this.items.forEach((item) => {
            if(item != clickedItem) {
                item.classList.remove('active');
                this.setExpanded(item, false);
            }
        })
    }

    closeMenuNow(item) {
        clearTimeout(this.timer);
        item.classList.remove('active');
        this.setExpanded(item, false);
        if (![...this.items].some((otherItem) => otherItem.classList.contains('active'))) {
            document.querySelector('body').classList.remove('desktop-menu-open');
        }
    }

    onTriggerKeydown(event) {
        const item = event.currentTarget;
        if (event.key === ' ' || event.key === 'Spacebar') {
            // Space toggles the submenu without following the link (Enter still
            // navigates natively, preserving the trigger's own destination).
            event.preventDefault();
            if (item.classList.contains('active')) {
                this.closeMenuNow(item);
            } else {
                this.menuOpen({ target: item });
            }
        } else if (event.key === 'Escape' && item.classList.contains('active')) {
            event.preventDefault();
            this.suppressFocusOpen = true;
            this.closeMenuNow(item);
            item.focus();
        } else if (event.key === 'ArrowDown' && item.classList.contains('active')) {
            const content = this.getContentFor(item);
            const firstLink = content && content.querySelector('.menu-links a, a.image-container');
            if (firstLink) {
                event.preventDefault();
                firstLink.focus();
            }
        }
    }

    onContentKeydown(event, item, content) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.suppressFocusOpen = true;
            this.closeMenuNow(item);
            item.focus();
        }
    }

    onFocusOut(event, item, content) {
        const next = event.relatedTarget;
        if (next && (item.contains(next) || (content && content.contains(next)))) {
            return;
        }
        this.closeMenuNow(item);
    }
}

customElements.define('mega-menu', MegaMenu);

class HeaderDrawer extends HTMLElement {
    constructor() {
        super();
        this.summary = this.querySelector('summary');
        this.parents = this.querySelectorAll('.parent > a');
        this.summary.addEventListener('click', this.summaryClick.bind(this))
        this.parents.forEach((item) => {
            item.addEventListener('click', this.itemClick.bind(this));
        });
    }
    
    itemClick(event) {
        event.preventDefault();
        const toggle = event.currentTarget;
        const parent = toggle.closest('.parent');
        const isActive = parent.classList.toggle('active');
        toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    }

    summaryClick(event) {
        if(this.summary.parentNode.hasAttribute('open')) {
            document.body.classList.remove('mobile-menu-open');
        } else {
            document.body.classList.add('mobile-menu-open');
        }
    }
}

customElements.define('header-drawer', HeaderDrawer);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class PopupTrigger extends HTMLElement {
  constructor() {
    super();
    this.popup = document.getElementById(this.dataset.trigger);
    if(this.popup) {
        if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
        if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
        this.addEventListener('click', this.onClick.bind(this))
        this.addEventListener('keydown', this.onTriggerKeydown.bind(this))
        this.popup.addEventListener('click', this.onPopupClick.bind(this))
        this.popup.addEventListener('keydown', this.onPopupKeydown.bind(this))
        this.close = this.popup.querySelectorAll('[data-close]')
        if(this.close) {
            this.close.forEach((close)=>{
                close.addEventListener('click', this.onClose.bind(this))
            })
        }
    }
  }

  onTriggerKeydown(event) {
    if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
        event.preventDefault();
        this.onClick(event);
    }
  }

  onPopupKeydown(event) {
    if (event.key === 'Escape') {
        event.preventDefault();
        this.onClose(event);
    }
  }

  onClose(event) {
    event.preventDefault();
    document.querySelector('body').classList.remove('fav-popup-open')
    this.popup.classList.remove('active')
    removeTrapFocus(this.activeElement || this)
  }

  onClick(event) {
    event.preventDefault();
    this.activeElement = document.activeElement;
    document.querySelector('body').classList.add('fav-popup-open')
    this.popup.querySelector('.loading-overlay').classList.remove('hidden')
    this.popup.classList.add('active')
    const focusTarget = this.popup.querySelector('[data-close]') || this.popup;
    trapFocus(this.popup, focusTarget);
    var self = this;
    var http = new XMLHttpRequest();
    let sectionSelector = this.dataset.sectionSelector;
    
    http.onreadystatechange = function () {
        if (this.readyState == 4) {
            try {
                
                // Convert the HTML string into a document object
                
                var parser = new DOMParser();
                var doc = parser.parseFromString(this.response, 'text/html');
                var elm = self.popup.querySelector('.content');
                self.popup.querySelector('.loading-overlay').classList.add('hidden')
                elm.innerHTML = doc.querySelector(sectionSelector).outerHTML;
                Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
                    const newScript = document.createElement("script");
                    Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                    oldScript.parentNode.replaceChild(newScript, oldScript);
                });
                // Newly-injected content can add focusable elements, so refresh
                // the focus trap boundaries without moving focus away.
                if (self.popup.classList.contains('active')) {
                    trapFocus(self.popup, document.activeElement && self.popup.contains(document.activeElement) ? document.activeElement : self.popup.querySelector('[data-close]'));
                }
//                             let event = new Event("swiper-loaded", {bubbles: true});
//                             document.body.dispatchEvent(event);
            } catch(err) {
                console.log(err.message + " in " + this.response);
                return;
            }
        }
    };
    
    let url = this.dataset.url;

    if( typeof url == 'undefined') {
        var elm = self.popup.querySelector('.content');
        self.popup.querySelector('.loading-overlay').classList.add('hidden')
        elm.innerHTML = document.querySelector(sectionSelector).outerHTML;
        elm.querySelector('.fav-tabs').classList.remove('hidden');
        Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
            const newScript = document.createElement("script");
            Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
            oldScript.parentNode.replaceChild(newScript, oldScript);
        });
        trapFocus(self.popup, document.activeElement && self.popup.contains(document.activeElement) ? document.activeElement : self.popup.querySelector('[data-close]'));
    } else {
        http.open('GET', url, true);
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.send();
    }

  }

  onPopupClick(event) {
      if(event.target.getAttribute('id') == this.dataset.trigger) {
        this.onClose(event);
    }
  }
}

customElements.define('popup-trigger', PopupTrigger);

class MediaZoom extends HTMLElement {
    constructor() {
        super();
        this.popup = document.getElementById('media-zoom');
        if(this.popup) {
            this.popup.addEventListener('click', this.onPopupClick.bind(this))
            this.popup.addEventListener('keydown', this.onPopupKeydown.bind(this))
            this.close = this.popup.querySelectorAll('[data-close]')
            if(this.close) {
                this.close.forEach((close)=>{
                    close.addEventListener('click', this.onClose.bind(this))
                })
            }
            this.popup.querySelectorAll('.swiper-button-prev-zoom, .swiper-button-next-zoom').forEach((navButton) => {
                navButton.addEventListener('keydown', (event) => {
                    if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
                        event.preventDefault();
                        navButton.click();
                    }
                });
            })
        }
        // Use event delegation on parent instead of attaching to individual containers
        const productMedia = document.querySelector('.product-media');
        if (productMedia) {
            productMedia.addEventListener('click', this.onImageClick.bind(this))
            productMedia.addEventListener('keydown', (event) => {
                if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
                    const imageContainer = event.target.closest('.image-container');
                    if (imageContainer) {
                        event.preventDefault();
                        imageContainer.click();
                    }
                }
            })
        }
        
        // Prevent swiper from handling video clicks - capture phase fires before swiper
        document.addEventListener('mousedown', (e) => {
            if (e.target.closest('video')) {
                e.preventDefault();
            }
        }, { capture: true, passive: false });


        
        document.addEventListener('click', (e) => {
            if (e.target.closest('video')) {
                // Force the video to open in popup on Safari Desktop
                e.preventDefault();
                // Prevents the Popup opening on mobile safari when tapping the video controls
                if (window.innerWidth <= 768) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                }
            }, { capture: true, passive: false });
    }

    onImageClick(event) {
        let imageContainer = event.target.closest('.image-container');
        if (!imageContainer) return;
        this.activeElement = document.activeElement;

        // Include all visible items (already filtered by Liquid for current variant) + items with "all" keyword
        let sameColors = document.querySelectorAll(`.product-media .image-container:not(.hidden)`)
        let index = Array.from(sameColors).indexOf(imageContainer);
        if (index === -1) index = 0;
        let slider = this.popup.querySelector('.swiper-wrapper')
        slider.innerHTML = ''
        if(sameColors.length > 0) {
            sameColors.forEach((container) => {
                let img = container.querySelector('img[srcset]')
                if(img) {
                    let item = document.createElement('div');
                    item.classList.add('swiper-slide');
                    let itemContainer = document.createElement('div');
                    itemContainer.classList.add('image-container');
                    itemContainer.classList.add('swiper-zoom-container');
                    let sliderImg = document.createElement('img');
                    sliderImg.setAttribute('src', img.dataset.full)

                    itemContainer.appendChild(sliderImg);
                    item.appendChild(itemContainer);
                    slider.appendChild(item);
                } else {
                    const video = container.querySelector('video')
                    const clone = video.cloneNode(true);
                    console.log(video);

                    let item = document.createElement('div');
                    item.classList.add('swiper-slide');
                    let itemContainer = document.createElement('div');
                    itemContainer.classList.add('image-container');

                    itemContainer.appendChild(clone);
                    item.appendChild(itemContainer);
                    slider.appendChild(item);
                }
            })
            this.showPopup(index)
        }
    }

  onClose(event) {
    event.preventDefault();
    document.querySelector('body').classList.remove('fav-popup-open')
    this.popup.classList.remove('active')
    // Pause videos in popup when closing
    const popupVideos = this.popup.querySelectorAll('video');
    popupVideos.forEach(v => {
        v.pause();
        v.currentTime = 0;
    });
    if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(this.activeElement || this);
    }
  }

  onPopupKeydown(event) {
    if (event.key === 'Escape') {
        event.preventDefault();
        this.onClose(event);
    }
  }

  showPopup(index=0) {
    document.querySelector('body').classList.add('fav-popup-open')
    // Pause all videos on PDP when modal opens
    const mainVideos = document.querySelectorAll('.product-media video');
    mainVideos.forEach(v => {
        v.pause();
        v.currentTime = 0;
    });
    this.popup.classList.add('active')
    this.swiper = new Swiper('#media-zoom .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: false,
        zoom: true,
        initialSlide: index,
//         loopAdditionalSlides:4,
        slidesPerView: 1,
        spaceBetween : 0,
        mousewheel: {
            forceToAxis: true,
        },
        navigation: {
            nextEl: '.swiper-button-next-zoom',
            prevEl: '.swiper-button-prev-zoom',
        },
        pagination: {
            el: '.swiper-zoom-pagination',
            type: 'progressbar',
        },
//         breakpoints: {
//             768: {
//                 direction: 'horizontal',
//             },
//         },
        on: {
            init: function (swiper) {
                // do something
                let slide = swiper.slides[swiper.activeIndex]
                let shift = slide.scrollWidth / 3;
                slide.scrollTo(shift, 0)
                // Reorder popup media by position after swiper initializes
                if (window.reorderMediaPosition) {
                    window.reorderMediaPosition('#media-zoom .swiper');
                }
            },
            slideChange: function (swiper) {
                // do something
                let slide = swiper.slides[swiper.activeIndex]
                let shift = slide.scrollWidth / 3;
                slide.scrollTo(shift, 0)
            },
        }
    });
//     this.popup.querySelector('.loading-overlay').classList.add('hidden')
    var self = this;
    if (typeof trapFocus === 'function') {
        const focusTarget = this.popup.querySelector('[data-close]') || this.popup;
        trapFocus(this.popup, focusTarget);
    }
  }

  onPopupClick(event) {
//       if(event.target.getAttribute('id') == this.dataset.trigger) {
//         this.onClose(event);
//     }
  }
}

customElements.define('media-zoom', MediaZoom);

window.addEventListener('DOMContentLoaded', (event) => {

    // Theme-specific selectors to make iframes responsive
    var iframeSelectors =
        '.article-template__content iframe[src*="youtube.com/embed"],' +
        '.article-template__content iframe[src*="player.vimeo"],' +
        '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
        '.custom__item-inner--html iframe[src*="player.vimeo"]';

    wrapIframe({
        iframes: document.querySelectorAll(iframeSelectors),
        iframeWrapperClass: 'video-wrapper'
    })
});

(function (ns, fetch) {
    ns.fetch = function() {
        const response = fetch.apply(this, arguments);
        response.then(res => {
            if (!res.ok || !res.url) return;
            const url = new URL(res.url);
            if (url.origin !== window.location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname)) return;

            return res.clone().json().then(data => {
                const items = Array.isArray(data.items) ? data.items : [data];
                items.forEach(customElevarAddToCart);
            });
        }).catch(error => {
            console.warn('Unable to track add to cart with Elevar:', error);
        });
        return response
    }
}(window, window.fetch));

function customElevarAddToCart(res) {
    const properties = res.properties || {};
    let event_name = 'dl_add_to_cart'
    let complete_the_look = false
    let atc_position = 'Primary'
    if(typeof properties['_complete_the_look'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        complete_the_look = true
        atc_position = 'Secondary'
    }
    if(typeof properties['_upsell'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        atc_position = 'Tertiary'
    }
    if(typeof properties['_gwp'] != 'undefined') {
        event_name = 'dl_add_to_cart'
        atc_position = 'Quaternary'
    }
    if(res.final_price == 0 ||
        res.url == '/collections/all'
    ) {
        return;
    }
    let price = res.final_price/100,
        compare_at_price = res.final_price < res.price ? res.price/100 : 0
  console.log('RES')
  console.log(res)
    const products = [
        {
            id: res.sku, // SKU
            name: res.product_title, // Product title
            brand: res.vendor,
            category: res.product_type,
            variant: res.variant_title,
            price: price.toString(), // TODO convert
            quantity: res.quantity.toString(), // Not required for dl_select_item & dl_view_item
//                 position: item.position, // Only required for dl_select_item; position in the list of search results, collection views and position in cart indexed starting at 1
            list: 'https://wolfandshepherd.com' + res.url, // The list the product was discovered from
            product_id: res.product_id.toString(), // The product_id
            variant_id: res.variant_id.toString(), // id or variant_id
            compare_at_price: compare_at_price.toString(), // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
            image: res.image, // If available, otherwise use an empty string
            fav: 'silution',
            url: 'https://wolfandshepherd.com' + res.url
//             inventory: "5" // If available, only required on dl_view_item
        },
    ]
    // console.log(atc_position);
    window.ElevarDataLayer.push({
        event: event_name,
//         user_properties: userProperties,
        ecommerce: {
            currencyCode: "USD",
            add: {
                actionField: {
                    action : 'add',
                    list: 'https://wolfandshepherd.com' + res.url // this should be the collection page URL that user clicked product from
                },
                complete_the_look: complete_the_look,
                atc_position: atc_position,
                products: products // See the products array below
            }
        }
    });
}
